'use strict';
import { livestream, payment, player, pusher } from './debug.js';

// Capture name constants.
// To add a new capture:
//   1. Add a constant here
//   2. Add the same value to Remote Config SENTRY_LOG_CAPTURE_NAMES

export const LOG_CAPTURE_LIVESTREAM_SEND_GIFT = 'livestream-send-gift';

// Which namespaces each capture is allowed to upload.
// e.g. 'livestream-send-gift' will upload logs from livestream:*, payment:*, pusher:*, player:*
export const LOG_CAPTURE_ALLOWED_NAMESPACES = {
  [LOG_CAPTURE_LIVESTREAM_SEND_GIFT]: [
    payment.namespace,
    livestream.namespace,
    pusher.namespace,
    player.namespace,
  ],
};
